import {
  useQueryStates,
  parseAsArrayOf,
  parseAsBoolean,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
} from 'nuqs'
import { ShiftStatus } from '../components/ShiftListFilters/ShiftFilters/StatusesFilter/constants'
import { RosterType } from '../components/ShiftListFilters/ShiftFilters/RosterRestrictions/constants'

const shiftStatusesParser = parseAsArrayOf<ShiftStatus>(
  parseAsStringLiteral(['active', 'cancelled'])
)

const rosterRestrictionsParser = parseAsArrayOf<RosterType>(
  parseAsStringLiteral(['permanent', 'temporary', 'non-roster'])
)

export const useShiftQueryState = () => {
  const queryStates = useQueryStates(
    {
      shiftIds: parseAsArrayOf(parseAsInteger).withDefault([]),
      listingIds: parseAsArrayOf(parseAsInteger).withDefault([]),
      locationIds: parseAsArrayOf(parseAsInteger).withDefault([]),
      marketCodes: parseAsArrayOf(parseAsString).withDefault([]),
      scheduleRateMin: parseAsInteger,
      scheduleRateMax: parseAsInteger,
      fillRateMin: parseAsInteger,
      fillRateMax: parseAsInteger,
      shiftStatuses: shiftStatusesParser.withDefault([]),
      positionIds: parseAsArrayOf(parseAsInteger).withDefault([]),
      rosterRestrictions: rosterRestrictionsParser.withDefault([]),
      isStandby: parseAsBoolean,
    },
    {
      urlKeys: {
        shiftIds: 'shift-ids',
        listingIds: 'listing-ids',
        locationIds: 'location-ids',
        marketCodes: 'market-codes',
        scheduleRateMin: 'schedule-rate-min',
        scheduleRateMax: 'schedule-rate-max',
        fillRateMin: 'fill-rate-min',
        fillRateMax: 'fill-rate-max',
        shiftStatuses: 'shift-statuses',
        positionIds: 'position-ids',
        rosterRestrictions: 'roster-restrictions',
        isStandby: 'is-standby',
      },
    }
  )

  return queryStates
}
